import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from 'common/components/Icon';
import { Button } from 'common/components/Form/Button';
import { Text } from 'common/styledComponents/typography';
import { SETTINGS_ROUTES } from 'settings/routes';
import { NoAccessCard, NoAccessIcon, NoAccessTitle } from 'modules/settings/components/DataExport/styled';

/** `admin`: the user cannot manage members. `feature`: an admin, but the organisation does not have data export. */
export type NoAccessReason = 'admin' | 'feature';

const ICONS = { admin: 'lock', feature: 'download' } as const;

/** Page-level state shown when someone opens /settings/data-export without access. */
const NoAccess: React.FC<{ reason: NoAccessReason }> = ({ reason }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <NoAccessCard role='status' data-testid='data-export-no-access'>
      <NoAccessIcon>
        <Icon icon={ICONS[reason]} size={26} color='latana' />
      </NoAccessIcon>
      <NoAccessTitle>{t(`dataExport.notAvailable.${reason}.title`)}</NoAccessTitle>
      <Text variant='body2' color='black50'>
        {t(`dataExport.notAvailable.${reason}.subtitle`)}
      </Text>
      <Button type='button' color='lightPurple' pill={false} isButtonV2 onClick={() => navigate(`/settings/${SETTINGS_ROUTES.PROFILE}`)}>
        {t('dataExport.notAvailable.back')}
      </Button>
    </NoAccessCard>
  );
};

export default React.memo(NoAccess);
